var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "expand_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11507",
    "data-name": "Path 11507",
    d: "M174.057,24H171.85a.414.414,0,0,0,0,.828h1.208l-3.967,3.967a.414.414,0,1,0,.585.585l3.967-3.967v1.208a.414.414,0,0,0,.828,0V24.414A.414.414,0,0,0,174.057,24Z",
    transform: "translate(-166.471 -24)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11508",
    "data-name": "Path 11508",
    d: "M31.586,27.862a.414.414,0,0,0-.414.414v2.9H24.828V24.828h2.9a.414.414,0,1,0,0-.828h-3.31a.414.414,0,0,0-.414.414v7.172a.414.414,0,0,0,.414.414h7.172A.414.414,0,0,0,32,31.586v-3.31A.414.414,0,0,0,31.586,27.862Z",
    transform: "translate(-24 -24)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.58047009215b7c2d52d5a4dae074b01f.svg";
export { ForwardRef as ReactComponent };